import type {CreateRevisionResponse, ServerCreateRevisionResponse} from './serverProtocolTypes'

export const convertToClientCreateRevisionResponse = (
    serverResult: ServerCreateRevisionResponse
): CreateRevisionResponse => {
    return {
        ...serverResult,
        siteRevision: {
            revision: Number(serverResult.siteRevision?.revision),
            version: Number(serverResult.siteRevision?.version)
        }
    }
}
